import React from 'react'

const RemarkContext = React.createContext({ align: 'left', color: 'default' })

export default RemarkContext
